export interface EntityProperties {
    id?: number;
    verNum?: number;
    createUserId?: any;
    createTime?: any;
    updateUserId?: any;
    updateTime?: any;
    deleted?: boolean;
}

export class Entity {
  constructor(kwArgs: EntityProperties = {}) {
    for (let key in kwArgs) {
      this[key] = kwArgs[key];
    }
  }
}
